import React from "react"
import { Spinner } from "reactstrap";

const Spinners = () => {


    return (
        <React.Fragment>
            <Spinner color="primary"  />
        </React.Fragment>
    )
}

export default Spinners;